import BaseDate from 'nast-date'

/**
 *
 */
export default class NastDate extends BaseDate {

}
